import { createSlice } from "@reduxjs/toolkit";
import {
  createAndSendInvoice,
  saveInvoice,
  downloadPdfInvoice,
  resendInvoice,
  fetchInvoices,
  fetchInvoiceById,
  deleteInvoice,
  paidInvoice,
  fetchInvoiceCounts,
  createInvoiceConfiguration,
  getInvoiceConfiguration,
} from "../service/invoiceService";

const invoiceInitialState = {
  invoiceData: null,
  invoiceTotalCount: null,
  isLoading: false,
  error: null,
  selectedInvoice: null,
  contactData: null,
  selectedInvoiceData: null,
  createInvoiceMode: null,
  createInvoiceClientMode: null,
  filteredData: {
    filteredDateCriteria: "createdAt",
    filteredDateRange: "",
    filteredProject: "",
    filteredClient: "",
    filteredInvoicedStatus: "",
  },
  toggleFilter: false,
  sortingData: {},
  filteredDataInClient: {
    filteredDateCriteria: "createdAt",
    filterdDateRange: '',
    filteredProject: '',
    filteredInvoicedStatus: '',
  },
  toggleFilterInClient: false,
  sortingDataInClient: {},
  filteredDataInProject: {
    filteredDateCriteria: "createdAt",
    filterdDateRange: '',
    filteredClient: '',
    filteredInvoicedStatus: '',
  },
  toggleFilterInProject: false,
  sortingDataInProject: {},
  invoiceConfiguration: {
    label: "Invoice",
    dueDays: "",
    customDays: "",
    taxes: [],
    note: "",
  },
};

export const invoiceSlice = createSlice({
  name: "invoices",
  initialState: invoiceInitialState,
  reducers: {
    editInvoice: (state, action) => {
      state.selectedInvoiceData = action.payload;
      state.selectedInvoice = action.payload;
      state.createInvoiceMode = null;
      state.createInvoiceClientMode = null;
    },
    createInvoiceModeAction: (state, action) => {
      state.createInvoiceMode = action.payload;
      state.selectedInvoiceData = null;
      state.createInvoiceClientMode = null;
    },
    createInvoiceClientModeAction: (state, action) => {
      state.createInvoiceClientMode = action.payload;
    },
    selectedInvoiceAction: (state, action) => {
      state.selectedInvoiceData = {
        ...state.selectedInvoiceData,
        ...action.payload,
      };
    },
    selectedContactInvoiceAction: (state, action) => {
      state.selectedInvoiceData = {
        ...state.selectedInvoiceData,
        ...action.payload,
      };
    },
    selectedInvoiceResetAction: (state) => {
      state.selectedInvoiceData = null;
      state.createInvoiceMode = null;
      state.selectedInvoice = null;
      state.createInvoiceClientMode = null;
    },

    filterAction: (state, action) => {
      state.filteredData = { ...state.filteredData, ...action.payload };
    },
    toggleAction: (state) => {
      state.toggleFilter = !state.toggleFilter;
    },
    sortingAction: (state, action) => {
      state.sortingData = { ...state.sortingData, ...action.payload };
    },
    filterActionInClient: (state, action) => {
      state.filteredDataInClient = {
        ...state.filteredDataInClient,
        ...action.payload,
      };
    },
    toggleActionInClient: (state) => {
      state.toggleFilterInClient = !state.toggleFilterInClient;
    },
    sortingActionInClient: (state, action) => {
      state.sortingDataInClient = {
        ...state.sortingDataInClient,
        ...action.payload,
      };
    },

    filterActionInProject: (state, action) => {
      state.filteredDataInProject = {
        ...state.filteredDataInProject,
        ...action.payload,
      };
    },
    toggleActionInProject: (state) => {
      state.toggleFilterInProject = !state.toggleFilterInProject;
    },
    sortingActionInProject: (state, action) => {
      state.sortingDataInProject = {
        ...state.sortingDataInProject,
        ...action.payload,
      };
    },

    updateContactList(state, action) {
      const invoices = state.invoiceData;
      if (!invoices || !invoices.length) return;

      for (const invoice of invoices) {
        if (invoice.client_id._id !== action.payload._id) continue;
        invoice.client_id.contacts = action.payload.contacts; return;
      }
    },
  },

  extraReducers: (builder) => {
    builder
      // create and send invoice
      .addCase(createAndSendInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createAndSendInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(createAndSendInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // save  invoice
      .addCase(saveInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(saveInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // save  invoice
      .addCase(downloadPdfInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(downloadPdfInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(downloadPdfInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // resend invoice
      .addCase(resendInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resendInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(resendInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch invoices
      .addCase(fetchInvoices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.invoiceData = action.payload.data.data;
        state.invoiceTotalCount = action.payload.data.invoiceTotalCount;
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch invoice by id
      .addCase(fetchInvoiceById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchInvoiceById.fulfilled, (state, action) => {
        state.selectedInvoiceData = action.payload.data;
        state.selectedInvoice = action.payload.data;
        state.isLoading = false;
      })
      .addCase(fetchInvoiceById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // delete invoice
      .addCase(deleteInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // paid invoice
      .addCase(paidInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(paidInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(paidInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // fetch invoice count
      .addCase(fetchInvoiceCounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchInvoiceCounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.invoiceTotalCount = action.payload.data.invoiceTotalCount;
      })
      .addCase(fetchInvoiceCounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // Create Invoice Configuration
      .addCase(createInvoiceConfiguration.pending, (state, action) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(createInvoiceConfiguration.fulfilled, (state, action) => {
        state.invoiceConfiguration = action.payload;
        state.isLoading = false;
      })
      .addCase(createInvoiceConfiguration.rejected, (state, action) => {
        state.error = action.error.message;
        state.isLoading = false;
      })

      // Get invoice configuration
      .addCase(getInvoiceConfiguration.pending, (state, action) => {
        state.error = "";
      })
      .addCase(getInvoiceConfiguration.fulfilled, (state, action) => {
        state.invoiceConfiguration = action.payload;
      })
      .addCase(getInvoiceConfiguration.rejected, (state, action) => {
        state.error = action.error.message;
      });
    },
});

export const invoiceActions = invoiceSlice.actions;
export const { updateContactList } = invoiceSlice.actions;
export default invoiceSlice.reducer;
